import GAAction from '../../analytics/actions.enum';

type CvUploadCompleteParams = {
    userid: number
    cvid: number
}

export const trackCvUploadComplete = ({ userid, cvid }: CvUploadCompleteParams) => {
    if (typeof window === 'undefined' || !window.dataLayer) return;

    window.dataLayer.push({
        event: GAAction.cvUploadComplete,
        userId: userid,
        cvId: cvid,
    });
};

type EmployerRegistrationCompleteParams = {
    userid: number
}

export const trackEmployerRegistrationComplete = ({ userid }: EmployerRegistrationCompleteParams) => {
    if (typeof window === 'undefined' || !window.dataLayer) return;

    window.dataLayer.push({
        event: GAAction.employerRegistrationComplete,
        userId: userid,
    });
};

type CandidateRegistrationCompleteParams = {
    userid: number
}

export const trackCandidateRegistrationComplete = ({ userid }: CandidateRegistrationCompleteParams) => {
    if (typeof window === 'undefined' || !window.dataLayer) return;

    window.dataLayer.push({
        event: GAAction.candidateRegistrationComplete,
        userId: userid,
    });
};

type SmartAgentRegistrationCompleteParams = {
    userid: number
}

export const trackSmartAgentRegistrationComplete = ({ userid }: SmartAgentRegistrationCompleteParams) => {
    if (typeof window === 'undefined' || !window.dataLayer) return;

    window.dataLayer.push({
        event: GAAction.smartAgentRegistrationComplete,
        userId: userid,
    });
};

type ContactUsCompleteParams = {
    userid?: number
}

export const trackContactUsComplete = ({ userid }: ContactUsCompleteParams = {}) => {
    if (typeof window === 'undefined' || !window.dataLayer) return;

    window.dataLayer.push({
        event: GAAction.contactUsComplete,
        ...(userid ? { userId: userid } : {}),
    });
};
